<template>
    <div class='consultationRecordStudentDetail'>
        <StudentDetail :data="data"></StudentDetail>
        <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
            <!--<Button @handleClick="submitForm('ruleForm',true)" :type="'btnGray'" name="预览" ></Button>-->
            <Button @handleClick="$router.go(-1)" :type="'btnBlue'" name="返回" ></Button>
        </div>
    </div>
</template>
<script>
import StudentDetail from '@/components/consultant/consultationRecord/StudentDetail.vue'
import Button from '@/components/Button.vue';
export default {
    name: "consultationRecordStudentDetail",
    components: {
        Button,
        StudentDetail
    },
    data() {
        return {
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            id: this.$route.query.id,
            data: {
            },
        }
    },
    created() {
        this.getInterviewFreeThemeDetail();
    },
    methods: {
        getInterviewFreeThemeDetail() {
            let id = this.id;
            this.$ajax.post(this.G_acapi + this.ports.student.student.consultationRecord.getInterviewFreeThemeDetailByStudent, {
                id: id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    this.data = res.data.data;
                }
            })
        }
    },
}
</script>

<style scoped lang="less">
.consultationRecordStudentDetail {
    .content {
        padding: 6px 30px 30px 30px;
        background-color: #fff;
        .topTheme {
            font-size: 20px;
            font-weight: 500;
            line-height: 30px;
            margin-bottom: 15px;
        }
        .lineBox {
            margin-bottom: 32px;
        }
    }
    .ftBtnBox {
        padding: 45px 0;
        display: flex;
        justify-content: center;
    }
}
</style>
<style lang="less">
.consultationRecordStudentDetail {
    .el-textarea {
        padding-top: 16px;
        textarea {
            background: rgba(61, 144, 246, 0.2);
            border-radius: 4px;
        }
    }
}
</style>